import Buefy from 'buefy';
import PreguntasFrecuentesContent from './PreguntasFrecuentesContent.vue';
// Registrar Buefy
Vue.use(Buefy);

// Registrar componentes
Vue.component('preguntas-frecuentes-content', PreguntasFrecuentesContent);


// Inicializar la app
new Vue({
    el: '#faq-app'
}); 